export default theme => ({
  Alert_Wrapper: {
    padding: theme.spacing.unit
  },
  Alert_Menu: {
    maxHeight: '300px',
    overflowY: 'auto',
    borderBottom: `1px solid ${theme.palette.gray.main}`,
    '&::-webkit-scrollbar': {
      width: '10px',
      borderRadius: '10px'
    },
  },
  Alert_Icon: {
    display: 'flex',
    width: `${theme.spacing.unit * 3.75}px`,
    height: `${theme.spacing.unit * 3.125}px`,
    color: theme.menus.icons
  },
  Alert_Header: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'baseline',
    marginBottom: theme.spacing.unit * 2
  },
  Alert_Popover: {
    overflow: 'hidden',
    width: `${theme.spacing.unit * 36.25}px`,
    padding: theme.spacing.unit
  },
  Alerts: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  Alert_areas: {
    fontSize: '12px',
    color: theme.palette.gray.dark
  },
  Alert_check: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    width: '26px',
    height: '26px'
  },
  Alert_date: {
    fontSize: '12px',
    color: theme.palette.gray.dark,
    padding: `0 ${theme.spacing.unit}px`
  },
  Alert_infos: {
    display: 'flex',
    alignItems: 'baseline'
  },
  Alert_Button: {
    display: 'flex',
    justifyContent: 'center'
  },
  Alert_Received: {
    background: theme.palette.cards.red,
    borderRadius: '100%',
    position: 'absolute',
    top: `${theme.spacing.unit * 3.25}px`,
    left: `${theme.spacing.unit * 2}px`,
    width: `${theme.spacing.unit}px`,
    height: `${theme.spacing.unit}px`
  },
  Alert_empty: {
    padding: theme.spacing.unit,
    color: theme.palette.gray.dark
  },
  Alert_count: {
    color: theme.palette.primary.main,
    fontSize: '12px'
  },
  Alert_Container: {
    marginBottom: theme.spacing.unit * 2
  }
})
